/**
 * Brand hop control — sunrise underline, Highstreet gray (#344054), SVG
 * arrow. Never an `<a>`: browser link blue is what this exists to avoid.
 */
import React from "react";

const Arrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M7 17 17 7M9 7h8v8" />
  </svg>
);

const HOP_CLASS =
  "inline-flex flex-shrink-0 items-center gap-1 border-b-2 border-sunrise pb-px text-xs font-medium text-primary-gray-light-700 hover:text-primary-gray-light-800";

export function HopAffordance({
  children,
  onClick,
  testId,
  as = "button",
}: {
  children: React.ReactNode;
  onClick?: () => void;
  testId?: string;
  /** Use `span` when this hop sits inside another button. */
  as?: "button" | "span";
}): React.ReactElement {
  if (as === "span") {
    return (
      <span data-testid={testId} className={HOP_CLASS}>
        {children}
        <Arrow />
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={HOP_CLASS}
    >
      {children}
      <Arrow />
    </button>
  );
}

export default HopAffordance;
